:host {
    // change this var to adjust floating buttons position
    --bottom-fixed: -10px;
    --btn-height: 80px;
    --header-height-mq1: 64px;
    --bottom: max(
        calc(100vh - 50vw + var(--half-of-small-slider) - 62px),
        calc(100vh - 80vh + var(--half-of-small-slider) - 62px)
    );

    display: flex;
    pointer-events: none;
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    bottom: var(--bottom);
    right: calc((var(--current-client-width) - 1760px) / 2 - 100px);
    z-index: 99;
    transition:
        bottom 0.5s,
        transform 0.5s,
        opacity 0.3s;
    gap: 12px;
    opacity: 1;
}

:host(.flyout-open) {
    z-index: 1000;
}

:host(.idle) {
    opacity: 0;

    .floating-buttons {
        > * {
            pointer-events: none;
        }
    }
}

:host(.idle:hover) {
    opacity: 1;

    .floating-buttons {
        > * {
            pointer-events: all;
        }
    }
}

.chat-btn,
.link-btn,
.contact-btn,
.scroll-to-top-btn {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    z-index: 2;
    height: var(--btn-height);
    box-shadow: 0 2px 15px -5px #000;
}

@keyframes glow {
    0% {
        box-shadow:
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    25% {
        box-shadow:
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    50% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    75% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 2px 15px -5px #000;
    }
    100% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 2px 15px -5px #000;
    }
}

.chat-btn,
.link-btn {
    background-color: $color-grey-02-steel;
    color: $color-white;
    animation: glow 3s linear;

    .icon {
        width: 80px;
        display: flex;
        justify-content: center;
    }

    .hover {
        max-width: 0;
        overflow: hidden;
        transition: max-width 0.6s;

        .title,
        .text {
            white-space: nowrap;
            padding-left: 32px;
        }

        .title {
            @include typo-ws-paragraph;
        }

        .text {
            @include typo-ws-paragraph-s;
        }
    }

    &:hover {
        .hover {
            max-width: 400px;
        }
    }
}

.link-btn {
    background-color: $color-white;
    color: $color-red;
    border: 1px solid $color-red;
    animation: none;

    .icon {
        width: 78px; // minus 2px because of border
    }

    .hover {
        .text {
            @include typo-ws-copy-xl-fixed;
        }
    }
}

.floating-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: 0.3s transform ease-in-out;
    align-items: flex-end;

    > * {
        pointer-events: all;
    }
}

.contact-btn {
    background-color: $color-red;
    color: $color-white;
    visibility: hidden;

    &.visible {
        visibility: visible;
    }

    .expanded {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        max-width: 0;
        animation: expandedArea 6s linear forwards 2s;
    }

    .svg {
        width: 60px;
        display: flex;
        justify-content: center;
    }

    .has-been-shown {
        animation: none;
        width: 0;
    }

    .title,
    .phone {
        margin-left: 32px;
        white-space: nowrap;
    }

    .title {
        @include typo-ws-paragraph-s;
    }

    .phone {
        @include typo-ws-copy-l;

        margin-top: -3px;
    }

    .icon {
        padding: 0 10px;
    }

    &:hover {
        .svg {
            transform: scale(1.1);
        }
    }
}

.scroll-to-top-btn {
    opacity: 0;
    background-color: $color-white;
    width: 80px;
    color: $color-red;
    border: 1px solid $color-red;

    .svg {
        transform: translateY(10%);
        transition: transform 0.2s;

        .shaft {
            opacity: 0;
            transition: opacity 0.2s;
        }
    }

    &:hover {
        .svg {
            transform: translateY(0);

            .shaft {
                opacity: 1;
            }
        }
    }

    &:active {
        background: $color-red;
        color: $color-white;
    }
}

:host(.no-stage),
:host(.scrolled) {
    position: fixed;
    bottom: var(--bottom-fixed);

    .scroll-to-top-btn {
        transform: translate3d(0, calc(var(--btn-height) + var(--bottom-fixed)), 0);
        transition:
            0.3s transform ease-in-out,
            opacity 900ms;
    }
}

:host(.scroll-to-top-visible) {
    .floating-buttons {
        transform: translate3d(0, calc(var(--btn-height) * -1), 0);
    }

    .scroll-to-top-btn {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

.flyout-layer {
    box-sizing: border-box;
    background-color: $color-white;
    padding: 44px 32px 40px;
    position: fixed;
    bottom: -20px; // to hide the shadow
    transform: translateY(100%);
    transition:
        bottom 500ms,
        top 500ms,
        transform 500ms,
        opacity 500ms;
    right: calc((var(--current-client-width) - 1760px) / 2 - 100px);
    box-shadow: 0 2px 15px -5px #000;
    z-index: 3;
    opacity: 0;
    pointer-events: all;
    width: min-content;
    min-width: 364px;

    &.open {
        bottom: calc(240px - var(--flyout-offset, 0));
        transform: translateY(0);
        opacity: 1;

        &.multi-button {
            bottom: calc(var(--multi-button-position) + 10px);

            &::after {
                position: absolute;
                content: '';
                background-color: $color-white;
                width: 30px;
                height: 30px;
                bottom: -14px;
                rotate: 135deg;
                box-shadow: rgb(0 0 0) 5px -5px 9px -6px;
                z-index: 3;
                opacity: 0;
                animation: arrowFadeIn 100ms 400ms forwards;
            }
        }

        &.multi-button.contact-flyout {
            &::after {
                right: 28px;
            }
        }

        &.multi-button.download-flyout,
        &.multi-button.whatsapp-flyout {
            &::after {
                right: 96px;
            }
        }

        &.multi-button.whatsapp-flyout.third {
            &::after {
                right: 163px;
            }
        }
    }

    .card-title {
        @include typo-ws-h3;

        margin: 0 0 24px;
    }

    .card-content {
        .headline {
            @include typo-ws-paragraph;
        }

        .text {
            @include typo-ws-copy-l-fixed;

            margin-top: 4px;
            color: inherit;
            text-decoration: none;

            @include mq-4-min {
                font-size: 32px;
                line-height: 44px;
            }
        }

        .help-text {
            @include typo-ws-paragraph-s;
        }
    }

    hr {
        all: unset;
        height: 1px;
        background-color: $color-grey-03;
        margin: 16px 0;
        display: block;
    }

    .close-icon {
        width: 28px;
        height: 28px;
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .close-icon:hover {
        cursor: pointer;
    }

    .search-field {
        margin-top: 32px;
    }

    sew-ws-linklist {
        margin-top: 32px;
    }

    img {
        width: 100%;
    }

    .highlight-title {
        @include typo-ws-h3;

        margin: 0 0 16px;
    }

    .highlight-headline {
        @include typo-ws-paragraph-bold;

        margin: 20px 0 0;
    }

    .highlight-text {
        @include typo-ws-paragraph;

        margin: 8px 0 0;
    }

    .tip-btn {
        margin-top: 24px;
        width: 100%;
    }

    .tip-opt-out-link {
        --link-color: $color-grey-02-steel;

        margin-top: 24px;
        cursor: pointer;
    }
}

@media (width <= 2020px) {
    :host {
        right: 40px;
    }

    .flyout-layer {
        right: 50px;
    }
}

@include mq-2 {
    .flyout-layer {
        right: 50px;
    }
}

@include mq-1 {
    :host {
        --bottom-fixed: -40px;

        position: fixed;
        bottom: var(--bottom-fixed);
        right: 20px; // +10px because position changed 10px because of scaling
    }

    .contact-btn,
    .scroll-to-top-btn,
    .chat-btn,
    .link-btn {
        scale: 0.75;
        margin: -10px 0;
        transform-origin: right;
    }

    .flyout-layer {
        top: 100vh;
        left: 0;
        width: 100vw;
        min-height: calc(100vh - var(--header-height-mq1));
        max-width: unset;
        overflow: auto;

        &.open {
            top: var(--header-height-mq1);
            bottom: 0;

            &::after {
                all: unset !important;
            }
        }

        ::slotted(sew-ws-button),
        sew-ws-link {
            margin-top: 32px;
        }
    }
}

@keyframes expandedArea {
    0% {
        max-width: 0;
    }

    10% {
        max-width: 400px;
    }

    90% {
        max-width: 400px;
    }

    100% {
        max-width: 0;
    }
}

@keyframes arrowFadeIn {
    from {
        bottom: 0;
    }

    to {
        opacity: 1;
        bottom: -14px;
        z-index: 4;
    }
}
